import { render, staticRenderFns } from "./CompareObjectsModal.vue?vue&type=template&id=46966ed4&"
import script from "./CompareObjectsModal.vue?vue&type=script&lang=js&"
export * from "./CompareObjectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports